module.exports = __webpack_public_path__ + "img/icon.a6e95e2f.png";